import { render, staticRenderFns } from "./Box14.vue?vue&type=template&id=6c642dc8&scoped=true&"
import script from "./Box14.vue?vue&type=script&lang=js&"
export * from "./Box14.vue?vue&type=script&lang=js&"
import style0 from "./Box14.vue?vue&type=style&index=0&id=6c642dc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c642dc8",
  null
  
)

export default component.exports